export default __webpack_public_path__ + "static/media/circles-no-7-remix.01c7fbe1.ogg";